// @ts-expect-error untyped dependency
import { getFormThemeName } from 'FormsUI/selectors/FormDefinition';
const getRoot = state => state.formThemes;
export const getFormThemes = state => Object.values(getRoot(state).themes || {});
export const getFormTheme = (state, themeName) => getRoot(state).themes[themeName];
export const getCurrentTheme = state => getRoot(state).themes[getFormThemeName(state)];
export const getFormThemesRequestState = state => getRoot(state).requestState;